import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { SearchIcon } from '@fiverr-private/visuals';
import { AppI18n } from '../../../../i18n';

export const RecentlyViewed = () => (
    <Stack gap="2" alignItems="center">
        <SearchIcon />
        <AppI18n k="highlights.recently_viewed" />
    </Stack>
);
